import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface SoundSettings {
  [GameSettingType.SettingOverallVolume]: number;
  [GameSettingType.SettingEnvironmentVolume]: number;
  [GameSettingType.SettingVoiceChatAndPhoneVolume]: number;
  [GameSettingType.SettingInterfaceSoundsVolume]: number;
  [GameSettingType.SettingCaseOpeningVolume]: number;
  [GameSettingType.SettingMenuInterfaceMusicVolume]: number;
  [GameSettingType.SettingInGameMusicVolume]: number;
  [GameSettingType.SettingRadioVolume]: number;
}

export interface SoundSettingsState {
  appliedSettings: SoundSettings | null;
  memoizedSettings: SoundSettings | null;
}

const initialState: SoundSettingsState = {
  appliedSettings: null,
  memoizedSettings: null,
};

const soundSettingsSlice = createSlice({
  name: "soundSettings",
  initialState,
  reducers: {
    setAppliedSettings: (state, action: PayloadAction<Partial<SoundSettings>>) => {
      state.appliedSettings = { ...state.appliedSettings, ...action.payload };
    },
    setMemoizedSettings: (state, action: PayloadAction<Partial<SoundSettings> | null>) => {
      if (action.payload) {
        state.memoizedSettings = { ...state.memoizedSettings, ...action.payload };
      } else {
        state.memoizedSettings = null;
      }
    },
    reset: (state) => {
      state.appliedSettings = { ...state.memoizedSettings };
    },
  },
});

export const soundSettingsSelector = (state: RootState) => state.soundSettings;
export const appliedSoundSettingsSelector = (state: RootState) =>
  state.soundSettings.appliedSettings;
export const memoizedSoundSettingsSelector = (state: RootState) =>
  state.soundSettings.memoizedSettings;

export const soundSettingsReducer = soundSettingsSlice.reducer;

export const { setAppliedSettings, setMemoizedSettings, reset } = soundSettingsSlice.actions;
